import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

class ReactSelect extends React.Component {
  state = {
    selectedOption: null
  };
  handleChange = (selectedOption,name) => {
    if( name !== 'asset' ){
      this.props.changeFormValue( selectedOption,name );
    }else {
      this.props.handleSelect( selectedOption, "single" );
      this.setState({ selectedOption: selectedOption });
    }

  };

  render() {
    const { selectedOption } = this.state;
    const { allValues, allSchemas, name, value } = this.props;
    let options = [];
    if(allSchemas){

      allSchemas.map(data => {
        options.push({
          value: data.name,
          label: data.name,
          id: data.id,
          key: this.props.state_key
        });
        return data;
      });
    } else if(allValues){
      allValues.choices.map(data => {
        options.push({
          value: data.name,
          label: data.name,
          id: data.key,
          key: data.key
        });
        return data;
      });
    }
    return options.length !== 0 && allSchemas &&(
      <Select
        name={name}
        clearable={false}
        value={selectedOption}
        onChange={(e)=> this.handleChange(e,name)}
        options={options}
      />
    ) || (
      <Select
        name={name}
        clearable={false}
        value={value}
        onChange={(e)=> this.handleChange(e,name)}
        options={options}
      />
    );
  }
}

export default ReactSelect;



// WEBPACK FOOTER //
// ./src/views/Projects/Projects/Select.js